import React from 'react';
import * as ds from './dataService';
import { VerticleFilterModalLayout } from 'modules/components/layer13';
import {
  Stack,
  FormControl,
  FormControlLabel,
  Checkbox
} from '@mui/material';


export type FilterDailyReportsModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: FilterDailyReportsModalProps) => {
  const {
    dispatch,
    formState,
    genFieldProps
  } = ds.useFormState();

  const fieldNames: (keyof typeof formState)[] = [
    'notSubmitted',
    'withAccidents',
    'withDeliveries',
    'withFiles',
    'withInspections'
  ];
  return (
    <VerticleFilterModalLayout.FC
      id={props.id}
      isVisible={props.isVisible}
      handleClose={() => props.handleClose()}
      successButton={{
        handleClick: () => {
          console.log(formState);
          props.handleClose();
        }
      }}
      cancelButton={{
        handleClick: () => {
          dispatch({
            type: 'RESET'
          });
        }
      }}
      title='Display Reports'
    >
      <Stack
        rowGap='.5rem'
        paddingY='.75rem'
      >
        {fieldNames.map((node, i) => (
          <FormControl
            key={i}

          >
            <FormControlLabel
              control={(
                <Checkbox
                  checked={formState[node]}
                  onClick={() => dispatch({
                    type: 'UPDATE',
                    payload: {
                      property: node,
                      value: !formState[node]
                    }
                  })}

                />
              )}
              label={genFieldProps(node).label}
            >

            </FormControlLabel>
          </FormControl>
        ))}
      </Stack>


    </VerticleFilterModalLayout.FC>
  );
};
